import React, { useState, useEffect, useMemo, useRef } from "react";
import { BPCLPlant } from "../../CompanyDashboard/services";
import { useFetcher, useNavigate, useParams } from "react-router-dom";
import {
  Button,
  ListItemText,
  MenuItem,
  Select,
  Checkbox,
  Box,
  Grid,
  Chip,
  Menu,
  FormControlLabel,
  Switch,
  IconButton,
} from "@mui/material";
import "./BPCL-soloar-plantDashboard.css";
import MapComponent1 from "../../../components/BPCL/PlantLocation/Map1";
import Datepicker3 from "../../../components/BPCL/Datepicker/Datepicker3";
import OpenInFullIcon from "@mui/icons-material/OpenInFull";
import CloseFullscreenIcon from "@mui/icons-material/CloseFullscreen";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { images } from "../../../config";
import PieChart from "../../../components/BPCL/Chart/PieChart";
import CombinedChart from "../../../components/BPCL/Chart/LineBarChart";
import AreaChart from "../../../components/BPCL/Chart/AreaChart";
import GuageChart from "../../../components/BPCL/Chart/GuageChart";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import PauseIcon from "@mui/icons-material/Pause";
import OverViewMachineMqttData from "../../SmartTag/MachineDashboard/mqttDataMachineDashboard/BpclmqttData";
import { SoftTagFormula } from "../../SmartTag/softTag/SoftTagFormula";
import {
  getHikemmREPlantDashboardGenerationCount,
  getHikemmREPlantCapacity,
  getHikemmREPlantDashboardCO2e,
  getHikemmREPlantDashboardCostSaving,
  getHikemmREDashboardTagsData,
  getHikemmREPlantDashboardCo2Count,
  getHikemmREPlantDashboardUtilizationCount,
  getHikemmREDashboardDailyGeneration,
  getCapacityGenerationTrend,
  getHikEMMREPlantDetails,
  getPlantProcessDashboardWeatherPeakData,
  insightsData,
  currentPRCUFData,
} from "../services";
import { useSelector } from "react-redux";
import LivePlantCombineChart from "../../../components/BPCL/Chart/LiveLineBarChart";
import SinglePlantCombineChart from "../../../components/BPCL/Chart/SingleLineBarChart";
import { ToastContainer, toast } from "react-toastify";
import Marquee from "react-fast-marquee";
import { cubejsApi } from "../../Cubejs/CubejsApiWrapper";
import HighlightOffRoundedIcon from "@mui/icons-material/HighlightOffRounded";
import Slider from "react-slick";
import SolarDatepicker from "../../../components/BPCL/Datepicker/SolarMapDatePicker";
import { evaluate } from "mathjs";

const SolarBPCLPlantDashboard = () => {
  const [active, setActive] = useState("");
  const [selectTimeRange, setSelectTimeRange] = useState("1min");
  const [plantData, setPlantData] = useState([]);
  const [allPlant, setAllPlant] = useState([]);
  const [SelctedplantLocation, setSelectedPlantLocation] = useState("");
  const [selectedPlantName, setSelectedPlantName] = useState("");
  const [selectedPlantImage, setSelectedPlantImage] = useState("");
  const [selectedPlantId, setSelectedPlantId] = useState([]);
  const [checkBoxPlantId, setCheckBoxPlantId] = useState([]);
  const [isAllSelected, setIsAllSelected] = useState(true);
  const [idleTimeout, setIdleTimeout] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [isSolarFullScreen, setIsFullscreen] = useState(false);
  const [showInfo, setShowInfo] = useState(false);
  const [showInfo1, setShowInfo1] = useState(false);
  const [showInfo2, setShowInfo2] = useState(false);
  const [showInfo3, setShowInfo3] = useState(false);
  const [dailyGenStartDate, setDailyGenStartDate] = useState(null);
  const [dailyGenEndDate, setDailyGenEndDate] = useState(null);
  const [tagListDataGroupAndList, setTagListDataGroupAndList] = useState([]);
  const [mqttTagPreviousvalue, setMqttTagPreviousvalue] = useState([]);
  const [topics, setTopics] = useState([]);
  const [realTimeData, setRealTimeData] = useState([]);
  const [chartRealTimeData, setChartRealTimeData] = useState([]);
  const [realTimePlantDta, setRealTimePlantData] = useState([]);
  const [chartRealTimePlantDta, setChartRealTimePlantData] = useState([]);
  const { selectTimeZoneProfile } = useSelector((state) => state.userState);
  const [sliderRealTimeTagData, setSliderRealTimeTagData] = useState([]);
  const [cubeData, setCubeData] = useState([]);
  const [mqttTagData, setMqttTagData] = useState([]);
  const [hikemmRePlantDetails, setHikemmRePlantDetails] = useState([]);
  const [isOthersChecked, setIsOthersChecked] = useState(false);
  const [capacity, setCapacity] = useState();
  const [anchorEl, setAnchorEl] = useState(null);
  const [dcValue, setDCValues] = useState([]);
  const [DCvalue, setDCValue] = useState([]);
  const [insightAPIData, setInsightsAPIData] = useState([]);
  const { plant_access } = useSelector((state) => state.userState);
  const [autoChange, setAutoChange] = useState(false); // switch default ON
  const [generationCurrentData, setGenartionCurrentData] = useState([]);
  const params = useParams();
  const allowedPlantIds = checkBoxPlantId.filter(id =>
    plant_access.some(access => access.id === id)
  );
 

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 5000,
  };

  const { isFullscreen } = useSelector((state) => state.headerState);
  const notifyError = (message) =>
    toast.error(message, {
      theme: "colored",
      position: toast.POSITION.TOP_RIGHT,
      toastClassName: "custom-toast",
    });

  const mergedArray = mqttTagData
    ? [].concat(...Object.values(mqttTagData))
    : [];

  const mqttDataReduce = mergedArray.reduce((map, item) => {
    if (!map[item.device__uid]) {
      map[item.device__uid] = {};
    }
    map[item.device__uid][item.device_tag] = Number(item.tagValue);
    return map;
  }, {});

  const handleDropdown = (event) => {
    setSelectTimeRange(event.target.value);
  };
  const fetchedInsightsOnMount = useRef(false);

  useEffect(() => {
    if (plantData.length > 0 && checkBoxPlantId.length > 0) {
      if (!fetchedInsightsOnMount.current) {
        // Prevent the first duplicate API call on mount
        fetchedInsightsOnMount.current = true;
        return;
      }
      handleInsights(); // API call only when checkBoxPlantId changes
    }
  }, [checkBoxPlantId]);

  const handleInsights = async () => {
    const params = {
      plant_ids: allowedPlantIds,
      insights_tag_unit: ["PR%", "CUF%", "MWh"],
      tag_ids: [
        6276, 6281, 6286, 6291, 6301, 6306, 6311, 6316, 6321, 6326, 6331, 6336,
        6341, 6346, 6351, 6356, 6361, 6366, 6371, 6376,
      ],
    };
    try {
      const resp = await insightsData(params);
      if (resp.status == 200 || resp.status == 201) {
        setInsightsAPIData(resp.data.payload);
      }
    } catch (error) {
      setInsightsAPIData([]);
    }
  };

  const getTagTime = () => {
    return new Date().toLocaleTimeString("en-US", {
      timeZone: selectTimeZoneProfile || "UTC",
      hour12: false,
    });
  };

  useEffect(() => {
    // Initial API call
    handleGenerationCurrentData();

    // Set interval for every 10 minutes
    const interval = setInterval(() => {
      handleGenerationCurrentData();
    }, 60000); // 60000 ms = 1 minutes

    // Cleanup interval on component unmount
    return () => clearInterval(interval);
  }, [checkBoxPlantId, startDate, endDate]);

  const handleGenerationCurrentData = async () => {
    // original params
    const params = {
      plant_ids: [56, 58, 59, 57],
      generation_tags: [5184, 5381, 5836, 6407],
      pr_tags: [5182, 5430, 5885, 6412],
      cuf_tags: [5186, 5429, 5884, 6411],
      plant_gti_tags: [5207, 5447, 5918, 6393],
    };
  
    // ✅ Filter logic
    const allowedIds = plant_access.map(p => p.id); // your plan_access array
    const filteredParams = {
      plant_ids: [],
      generation_tags: [],
      pr_tags: [],
      cuf_tags: [],
      plant_gti_tags: [],
    };
  
    params.plant_ids.forEach((id, index) => {
      if (allowedIds.includes(id)) {
        filteredParams.plant_ids.push(id);
        filteredParams.generation_tags.push(params.generation_tags[index]);
        filteredParams.pr_tags.push(params.pr_tags[index]);
        filteredParams.cuf_tags.push(params.cuf_tags[index]);
        filteredParams.plant_gti_tags.push(params.plant_gti_tags[index]);
      }
    });
  
    // ✅ Apply date filters
    if (startDate && endDate) {
      filteredParams.start_date = `${startDate} 00:00:00`;
      filteredParams.end_date = `${endDate} 23:59:59`;
    }
    if (!startDate && !endDate) {
      filteredParams.time_period = 1;
    }
  
    try {
      const resp = await currentPRCUFData(filteredParams); // use filtered params
      if (resp.status === 200 || resp.status === 201) {
        setGenartionCurrentData(resp.data.payload);
      }
    } catch (error) {
      console.log("handleGenerationCurrentData error", error);
    }
  };
  



  useEffect(() => {
    setCubeData([]);
  }, [selectTimeRange]);
  const executeCubeQuery = async () => {
    try {
      let currentTime;

      // Simplify the time logic, as it's the same for all time ranges
      if (["1min", "5min", "15min", "Hour"].includes(selectTimeRange)) {
        currentTime = new Date().toLocaleTimeString("en-US", {
          timeZone: selectTimeZoneProfile || "UTC",
          hour12: false,
        });
      }

      const mwTags = chartRealTimeData.filter((row) => row.tag_unit === "MW");

      // Fetch the data from Cube.js
      const chartGraph = await cubejsApi.load({
        dimensions: [
          "DeviceConfigurationTagconfiguration.latestValue",
          "DeviceConfigurationTagconfiguration.tagName",
          "DeviceConfigurationTagconfiguration.deviceId",
        ],
        filters: [
          {
            member: "DeviceConfigurationTagconfiguration.tagid",
            operator: "equals",
            values: mwTags.length
              ? mwTags.map((row) => row.tag_id.toString()) // Convert tag_id to string
              : [],
          },
        ],
        limit: 4,
      });

      // Extract the pivoted data once
      const chartData = chartGraph.tablePivot() || [];

      console.log("mwTags", mwTags);

      // Process the fetched data
      const processedData = chartData.map((row, i) => {
        // Find the plant that matches the deviceId
        const plant = realTimePlantDta.find((plant) =>
          plant.tags.some(
            (tag) =>
              tag.device === row["DeviceConfigurationTagconfiguration.deviceId"]
          )
        );

        // If a matching plant is found, assign its name
        const plantName = plant ? plant.plant_name : "Unknown"; // Default to "Unknown" if no match

        return {
          plant_name: plantName, // Use the matched plant name
          plantId: plant.plant_id,
          color: (() => {
            // Find the index of the plant in plantData
            const plantIndex = plantData.findIndex(
              (p) => p.id === plant.plant_id
            );
            // Use the index to fetch the color from colorCode
            return plantIndex !== -1 ? colorCode[plantIndex] : "#cccccc"; // Fallback color if no match
          })(),
          tags: [
            {
              tag_name: row["DeviceConfigurationTagconfiguration.tagName"],
              data: row["DeviceConfigurationTagconfiguration.latestValue"],
              tagTime: currentTime, // Set tagTime here based on current time
              // plantName: plantName, // Pass plantName here as well
            },
          ],
        };
      });
      // Update the state with the new data added to the previous data
      setCubeData((prev) => {
        // Create a shallow copy of the previous state
        const updatedData = [...prev];

        // Loop through the new data to check if it exists in the previous state
        processedData.forEach((newData) => {
          const existingPlantIndex = updatedData.findIndex(
            (plant) => plant.plant_name === newData.plant_name
          );

          if (existingPlantIndex !== -1) {
            const existingPlant = updatedData[existingPlantIndex];
            const existingTags = existingPlant.tags;

            // Check if the tag already exists and whether the tagTime matches
            const tagExists = existingTags.some(
              (tag) =>
                tag.tag_name === newData.tags[0].tag_name &&
                tag.data === newData.tags[0].data &&
                tag.tagTime === newData.tags[0].tagTime // Compare the tagTime as well
            );

            if (!tagExists) {
              // Add new tag to the existing tags array if it doesn't exist
              existingTags.push(newData.tags[0]);
            }
          } else {
            // If the plant doesn't exist, add it to the updated data
            updatedData.push(newData);
          }
        });

        return updatedData; // Return the updated state, keeping both old and new data
      });
    } catch (error) {
      console.error("Cube query error:", error);
    }
  };

  useEffect(() => {
    if (chartRealTimeData.length) {
      // Function to execute the cube query

      // Set interval to execute the cube query based on selectTimeRange
      let interval = null;
      switch (selectTimeRange) {
        case "1min":
          interval = setInterval(executeCubeQuery, 60000);
          break;
        case "5min":
          interval = setInterval(executeCubeQuery, 300000);
          break;
        case "15min":
          interval = setInterval(executeCubeQuery, 900000);
          break;
        case "Hour":
          interval = setInterval(executeCubeQuery, 3600000);
          break;
        default:
          clearInterval(interval); // Clear interval if selectTimeRange is not supported
      }

      // Execute the cube query immediately
      executeCubeQuery();

      // Clean up the interval when the component unmounts or when selectTimeRange changes
      return () => {
        clearInterval(interval);
      };
    }
  }, [chartRealTimeData, selectTimeRange]);

  useEffect(() => {
    getPlantByCompany();
  }, [active]);

  const getPlantByCompany = async () => {
    try {
      const param = {
        dashboard: 1,
        company: params.id,
      };

      const resp = await BPCLPlant(param, active);
      if (resp.status == 200) {
        setPlantData(resp.data.payload);
        setAllPlant(resp.data.payload.map((e) => e.plant_location));
      }
    } catch (error) {
      console.log("Error from getPlantByCompany...", error);
    }
  };

  // useEffect(() => {
  //   const today = new Date().toISOString().split("T")[0]; // Format: YYYY-MM-DD
  //   setStartDate(today);
  //   setEndDate(today);
  //   setDailyGenStartDate(today);
  //   setDailyGenEndDate(today);
  // }, []);

  const has58 = checkBoxPlantId[0] == 58;
  const has59 = checkBoxPlantId[0] == 59;
  const handleGenerationDCValue = async () => {
    const param = {
      plant_id: checkBoxPlantId[0],
      weather_tags: [
        has58 ? 4244 : has59 ? 5923 : 1,
        has58 ? 4265 : has59 ? 5944 : 1,
        has58 ? 4286 : has59 ? 5965 : 1,
        has58 ? 4307 : has59 ? 5986 : 1,
        has58 ? 4328 : has59 ? 6007 : 1,
        has58 ? 4349 : has59 ? 6028 : 1,
        has58 ? 4370 : has59 ? 6049 : 1,
        has58 ? 4391 : has59 ? 6070 : 1,
        has58 ? 4412 : has59 ? 6091 : 1,
        has58 ? 4433 : has59 ? 6112 : 1,
        has58 ? 4538 : has59 ? 6133 : 1,
        has58 ? 4454 : has59 ? 6154 : 1,
        has58 ? 4475 : has59 ? 6175 : 1,
        has58 ? 4496 : has59 ? 6196 : 1,
        has58 ? 4517 : has59 ? 6217 : 1,
        has59 ? 6238 : 1,
        has59 ? 6259 : 1,
      ],
    };
    try {
      const resp = await getPlantProcessDashboardWeatherPeakData(param);
      if (resp.status === 200 || resp.status === 201) {
        const tagsData = resp.data.payload;
        setDCValues(tagsData);

        const tagDataList = tagsData.map((e) => {
          const obj = {
            dvName: e.device_tag || "-",
            tagName: e.tag_name,
            machineUID: e.device_uid,
            is_soft_tag: e.is_soft_tag || false,
            soft_tag_id__formula: e.soft_tag_id__formula,
          };
          return obj;
        });

        // Combine default and calculated tags if needed
        setTagListDataGroupAndList(tagDataList);

        // Evaluate formula if it’s a soft tag
        const evaluateSoftTagValue = (formula, tags) => {
          try {
            const tagPattern = /[A-Za-z0-9_]+/g;
            const tagMatches = formula.match(tagPattern) || [];
            // let evaluatedFormula = formula;
            let variables = {};

            // Replace tags in formula with current values from tags list
            tagMatches.forEach((tag) => {
              const foundTag = tags.find((t) => t.dvName === tag);
              const tagValue = foundTag ? parseFloat(foundTag.curValue) : 0;
              // evaluatedFormula = evaluatedFormula.replace(tag, tagValue);
              variables[tag] = foundTag ? parseFloat(foundTag.curValue) : 0;
            });
            // console.log("evaluatedFormula", evaluatedFormula);
            // return eval(evaluatedFormula);
            return evaluate(formula, variables);
          } catch {
            return 0; // Default to 0 on error
          }
        };

        const tagObj = tagsData.map((e) => {
          let curValue = 0;
          let prevValue = 0;

          if (e.is_soft_tag && e.soft_tag_id__formula) {
            curValue = evaluateSoftTagValue(
              e.soft_tag_id__formula,
              mqttTagPreviousvalue
            );
            prevValue = curValue;
          }

          const obj = {
            is_soft_tag: e.is_soft_tag,
            dvName: e.device_tag || "-",
            prevValue,
            curValue,
            dateAndTime: getTagDateAndTime(),
            soft_tag_id__formula: e.soft_tag_id__formula,
          };
          return obj;
        });

        setMqttTagPreviousvalue(tagObj);
      }
    } catch (error) {
      console.log("Error in handleRealTimeData:", error);
    }
  };

  const fetchedGenerationDCValueOnMount = useRef(false);

  useEffect(() => {
    if (plantData.length > 0 && checkBoxPlantId.length > 0) {
      if (!fetchedGenerationDCValueOnMount.current) {
        // Prevent the first duplicate API call on mount
        fetchedGenerationDCValueOnMount.current = true;
        return;
      }
      handleGenerationDCValue(); // API call only when checkBoxPlantId changes
    }
    // Set up interval to call handleRealTimeData every 1 minute
    const intervalId = setInterval(() => {
      handleGenerationDCValue();
    }, 60000); // 60000 milliseconds = 1 minute

    // Clean up the interval on component unmount
    return () => clearInterval(intervalId);
  }, [checkBoxPlantId]);

  useEffect(() => {
    let totalDCValue = 0;

    const updatedDCValues = dcValue.map((dc) => {
      let DCLiveValue = 0.0;

      // Find the matching value from mergedArray
      if (mergedArray.length) {
        DCLiveValue = Number(
          mergedArray.find(
            (f) =>
              f.device__uid == dc.device_uid && f.device_tag == dc.device_tag
          )?.["tagValue"] || 0.0
        );
      }

      // If it's a soft tag, apply the formula
      if (
        dc?.is_soft_tag &&
        dc?.soft_tag_id__formula &&
        Object.keys(mqttDataReduce).length
      ) {
        const softTagFormulaResult = SoftTagFormula(
          dc.soft_tag_id__formula,
          mqttDataReduce
        );

        if (softTagFormulaResult?.softTagNotGetTag) {
          DCLiveValue = Number(softTagFormulaResult.value);
        }
      }

      return { ...dc, DCLiveValue };
    });
    // Remove old values and add new values
    totalDCValue = updatedDCValues.reduce((sum, dc) => {
      let value = dc.DCLiveValue;

      if (has58) {
        value = dc.DCLiveValue / 1000;
      }

      if (has59) {
        value = dc.DCLiveValue / 1000;
      }

      return sum + value;
    }, 0);

    setDCValue(totalDCValue);
  }, [mergedArray, dcValue, has59, has58]);

  // Initially select all plants
  useEffect(() => {
    if (isAllSelected) {
      const allPlantIDs = plantData.map((plant) => plant.id);
      setSelectedPlantId(["all", ...allPlantIDs]);
      setCheckBoxPlantId(allPlantIDs);
    }
  }, [isAllSelected, plantData]);

  useEffect(() => {
    const allPlantIDs = plantData.map((plant) => plant.id);
    // Check if all `allPlantIDs` are in `selectedPlantId`
    const isAllSelected = allPlantIDs.every((id) =>
      selectedPlantId.includes(id)
    );
    // Update `isAllSelected` state
    setIsAllSelected(isAllSelected);
    // If not all are selected, remove "all" from `selectedPlantId`
    if (!isAllSelected && selectedPlantId.includes("all")) {
      setSelectedPlantId((prev) => prev.filter((id) => id !== "all"));
    }
  }, [selectedPlantId, plantData]);

  const handlePlantSelected = (plantIds) => {
    const allPlantIDs = plantData.map((plant) => plant.id);

    // If "All Plants" is selected
    if (plantIds.includes("all")) {
      if (isAllSelected) {
        // Unselect all if "All Plants" is already selected
        setIsAllSelected(false);
        setSelectedPlantId([]); // Deselect all plants
        setCheckBoxPlantId([]); // Deselect checkboxes
        setIsOthersChecked(false); // Ensure "Others" is deselected when "All Plants" is unselected
        setHikemmRePlantDetails([]);
      } else {
        // Select all if "All Plants" is not selected
        setIsAllSelected(true);
        setSelectedPlantId(["all", ...allPlantIDs]);
        setCheckBoxPlantId(allPlantIDs);
        setIsOthersChecked(false); // Ensure "Others" is deselected when "All Plants" is selected
        setHikemmRePlantDetails([]);
      }
    }
    // If "Others" is selected
    else if (plantIds.includes("others")) {
      console.log("Others selected");
      setIsOthersChecked(!isOthersChecked); // Toggle "Others"
      if (!isOthersChecked) {
        setSelectedPlantId(["others"]);
        setCheckBoxPlantId([]); // Reset other checkboxes
        setIsAllSelected(false);
      } else {
        setSelectedPlantId([]);
        setCheckBoxPlantId([]);
        setIsAllSelected(false);
      }
      setIsAllSelected(false); // Ensure "All Plants" is deselected when "Others" is selected
    }
    // Handle individual plant selection or deselection
    else {
      const updatedSelected = [...selectedPlantId];

      plantIds.forEach((id) => {
        if (updatedSelected.includes(id)) {
          // If the plant is already selected, deselect it
          const index = updatedSelected.indexOf(id);
          if (index > -1) updatedSelected.splice(index, 1);
        } else {
          // If the plant is not selected, select it
          updatedSelected.push(id);
        }
      });

      setSelectedPlantId(updatedSelected);
      setCheckBoxPlantId(updatedSelected); // Update the checkbox state

      // Ensure "Others" is deselected if any plant is selected
      setIsOthersChecked(false);
      setHikemmRePlantDetails([]);
    }
  };

  const handleMenuClick = (event) => {
    // This sets the anchor for the menu, making it open at the button's position
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null); // Closes the menu when clicked outside
  };
  useEffect(() => {
    if (selectedPlantId.length == 1) {
      const selectedPlant = plantData.find(
        (plant) => plant.id === selectedPlantId[0]
      );
      if (selectedPlant) {
        setSelectedPlantLocation(selectedPlant.plant_location);
      }
    } else {
      setSelectedPlantLocation("");
    }
  }, [selectedPlantId]);

  const selectNextPlant = () => {
    const allPlantIds = plantData.map((plant) => plant.id); // Array of all plant IDs
    const currentIndex = plantData.findIndex(
      (plant) => plant.id === selectedPlantId[0]
    ); // Find the current index

    if (selectedPlantId.includes("all")) {
      // If "All Plants" is currently selected, move to the first plant
      const firstPlantId = plantData[0]?.id;
      setSelectedPlantId([firstPlantId]); // Set to the first plant ID
      setCheckBoxPlantId([firstPlantId]);
      setIsOthersChecked(false);
      setHikemmRePlantDetails([]);
    } else if (currentIndex === plantData.length - 1) {
      // If the current plant is the last in the list, move back to "All Plants"
      setSelectedPlantId(["all", ...allPlantIds]); // Select "All Plants"
      setCheckBoxPlantId(allPlantIds);
      setIsOthersChecked(false);
      setHikemmRePlantDetails([]);
    } else {
      // Otherwise, move to the next plant in the list
      const nextPlant = plantData[currentIndex + 1];
      setSelectedPlantId([nextPlant.id]); // Set to the next plant ID
      setCheckBoxPlantId([nextPlant.id]);
      setIsOthersChecked(false);
      setHikemmRePlantDetails([]);
    }
  };

  const selectPreviousPlant = () => {
    const allPlantIds = plantData.map((plant) => plant.id); // Array of all plant IDs
    const currentIndex = plantData.findIndex(
      (plant) => plant.id === selectedPlantId[0]
    ); // Find the current index

    if (selectedPlantId.includes("all")) {
      // If "All Plants" is currently selected, move to the last plant
      const lastPlantId = plantData[plantData.length - 1]?.id;
      setSelectedPlantId([lastPlantId]); // Set to the last plant ID
      setCheckBoxPlantId([lastPlantId]);
      setIsOthersChecked(false);
      setHikemmRePlantDetails([]);
    } else if (currentIndex === 0) {
      // If the current plant is the first in the list, move back to "All Plants"
      setSelectedPlantId(["all", ...allPlantIds]); // Select "All Plants"
      setCheckBoxPlantId(allPlantIds);
      setIsOthersChecked(false);
      setHikemmRePlantDetails([]);
    } else {
      // Otherwise, move to the previous plant in the list
      const prevPlant = plantData[currentIndex - 1];
      setSelectedPlantId([prevPlant.id]); // Set to the previous plant ID
      setCheckBoxPlantId([prevPlant.id]);
      setIsOthersChecked(false);
      setHikemmRePlantDetails([]);
    }
  };

  const timeoutId = useRef(null);
  const inactivityTimeout = 1000 * 10 * 1;

  const resetIdleTimer = () => {
    clearTimeout(timeoutId.current);
    if (autoChange) {
      timeoutId.current = setTimeout(selectNextPlant, inactivityTimeout);
    }
  };

  useEffect(() => {
    if (!hikemmRePlantDetails.length) {
      resetIdleTimer();

      const handleActivity = () => resetIdleTimer();

      document.addEventListener("mousemove", handleActivity);
      document.addEventListener("click", handleActivity);
      document.addEventListener("keydown", handleActivity);
      document.addEventListener("touchstart", handleActivity);

      return () => {
        document.removeEventListener("mousemove", handleActivity);
        document.removeEventListener("click", handleActivity);
        document.removeEventListener("keydown", handleActivity);
        document.removeEventListener("touchstart", handleActivity);
        clearTimeout(timeoutId.current);
      };
    }
  }, [
    selectedPlantId,
    plantData,
    checkBoxPlantId,
    hikemmRePlantDetails,
    autoChange,
  ]);

  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullscreen(document.fullscreenElement !== null);
    };

    document.addEventListener("fullscreenchange", handleFullscreenChange);

    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
    };
  }, []);

  const toggleFullscreen = () => {
    const mapContainer = document.getElementById("map-container");
    if (!isSolarFullScreen) {
      setIsFullscreen(true);
      try {
        if (mapContainer.requestFullscreen) {
          mapContainer.requestFullscreen();
        } else if (mapContainer.webkitRequestFullscreen) {
          mapContainer.webkitRequestFullscreen();
        } else if (mapContainer.msRequestFullscreen) {
          mapContainer.msRequestFullscreen();
        }
      } catch (error) {
        console.error("Fullscreen request failed:", error);
      }
    } else {
      setIsFullscreen(false);
      try {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      } catch (error) {
        console.error("Fullscreen exit failed:", error);
      }
    }
  };

  const [totalGeneration, setTotalGeneration] = useState([]);
  const [totalCapacity, setTotalCapacity] = useState([]);
  const [totalCapacityChartData, setTotalCapacityChartData] = useState([]);
  const [co2Emission, setCo2Emission] = useState([]);
  const [co2CountData, setCo2CountData] = useState([]);
  const [co2Percentage, setCo2Percentage] = useState([]);
  const [costSaving, setCostSaving] = useState([]);
  const [costUnit, setCostUnit] = useState([]);
  const [utilityCountData, setUtilityCountData] = useState([]);
  const [utilityPercentage, setUtilityPercentage] = useState([]);
  const [generationData, setGenerationData] = useState([]);
  const [dailyGenerationData, setDailyGenerationData] = useState([]);
  const [summationValue, setSummationValue] = useState([]);
  const [updatedValues, setUpdatedValues] = useState([]);
  const [averageValues, setAverageValue] = useState([]);
  const [co2BoxData, setCo2BoxData] = useState([]);
  const [costBoxData, setCostBoxData] = useState([]);

  const [capacityGenerationTrendData, setCapacityGenerationTrendData] =
    useState([]);

  const getTagDateAndTime = () => {
    return new Date().toLocaleString("en-US", {
      timeZone: selectTimeZoneProfile || "UTC",
      hour12: false,
    });
  };
  const handleRealTimeData = async () => {
    const allowedIds = plant_access.map(p => p.id);
    const params = {
      plant_ids: allowedPlantIds,
      generation_tag_unit: "MW",
      co2_e_tag_unit: "kt",
      cost_saving_tag_unit: "Lac",
      performance_tag_unit: "PR%",
      utilization_tag_unit: "CUF%",
    };
    try {
      const resp = await getHikemmREDashboardTagsData(params);
      if (resp.status == 200 || resp.status == 201) {
        const tagsData = resp.data.payload;
        setRealTimePlantData(tagsData);
        setChartRealTimePlantData(tagsData);
        const tagDataList = tagsData.flatMap((plant) =>
          plant.tags.map((tag) => ({
            dvName: tag.device_tag || "-",
            tagName: tag.tag_name,
            machineUID: tag.device_uid,
            is_soft_tag: tag.is_soft_tag || false,
            soft_tag_id__formula: tag.soft_tag_id__formula || null,
          }))
        );

        // Combine default and calculated tags if needed
        setTagListDataGroupAndList(tagDataList);

        // Evaluate formula if it’s a soft tag
        const evaluateSoftTagValue = (formula, tags) => {
          try {
            const tagPattern = /[A-Za-z0-9_]+/g;
            const tagMatches = formula.match(tagPattern) || [];
            let evaluatedFormula = formula;

            // Replace tags in formula with current values from tags list
            tagMatches.forEach((tag) => {
              const foundTag = tags.find((t) => t.dvName === tag);
              const tagValue = foundTag ? parseFloat(foundTag.curValue) : 0;
              evaluatedFormula = evaluatedFormula.replace(tag, tagValue);
            });
            return eval(evaluatedFormula);
          } catch {
            return 0; // Default to 0 on error
          }
        };

        const tagObj = tagsData.flatMap((plant) =>
          plant.tags.map((tag) => {
            let curValue = 0;
            let prevValue = 0;

            if (tag.is_soft_tag && tag.soft_tag_id__formula) {
              // Evaluate the formula for the soft tag using the provided method
              curValue = evaluateSoftTagValue(
                tag.soft_tag_id__formula,
                mqttTagPreviousvalue
              );
              prevValue = curValue; // Assuming prevValue is the same as curValue initially
            }

            return {
              is_soft_tag: tag.is_soft_tag,
              dvName: tag.device_tag || "-",
              prevValue,
              curValue,
              dateAndTime: getTagDateAndTime(),
              soft_tag_id__formula: tag.soft_tag_id__formula,
            };
          })
        );

        setMqttTagPreviousvalue(tagObj);
      }
    } catch (error) {
      console.log("handlesubmit", error);
    }
  };

  const mergeTopics = (existingTopics, newTopics) => {
    return Array.from(new Set([...existingTopics, ...newTopics]));
  };

  useEffect(() => {
    if (realTimePlantDta.length) {
      const topicArray = realTimePlantDta.flatMap((plant) =>
        plant.tags.map((tag) => "Hikar/DeviceUID/" + tag.device_uid)
      );
      setTopics((prevTopics) => mergeTopics(prevTopics, topicArray));
    }
  }, [realTimePlantDta]);

  useEffect(() => {
    if (dcValue.length) {
      const topicArray = dcValue.map((e) => "Hikar/DeviceUID/" + e.device_uid);
      // console.log("topicArray", topicArray);
      // setTopics(topicArray);
      setTopics((prevTopics) => mergeTopics(prevTopics, topicArray));
    }
  }, [dcValue]);

  useEffect(() => {
    if (realTimePlantDta.length) {
      const onlyTags = realTimePlantDta.flatMap((plant) => plant.tags);
      setRealTimeData(onlyTags);
    }
  }, [realTimePlantDta]);

  useEffect(() => {
    if (chartRealTimePlantDta.length) {
      const onlyTags = chartRealTimePlantDta.flatMap((plant) => plant.tags);
      setChartRealTimeData(onlyTags);
    }
  }, [chartRealTimePlantDta]);

  const plantIds = useMemo(() => plantData.map((e) => e.id), [plantData]);

  const fetchedRealTimeDataOnMount = useRef(false);

  useEffect(() => {
    if (plantData.length > 0 && checkBoxPlantId.length > 0) {
      if (!fetchedRealTimeDataOnMount.current) {
        // Prevent the first duplicate API call on mount
        fetchedRealTimeDataOnMount.current = true;
        return;
      }
      handleRealTimeData(); // API call only when checkBoxPlantId changes
    }
  }, [plantIds, checkBoxPlantId]);

  useEffect(() => {
    const updatedValues = realTimePlantDta.map((plant) => {
      const matchingData = plant.tags?.reduce((acc, tag) => {
        const tagData = mergedArray.find(
          (item) =>
            item.device__uid === tag.device_uid &&
            item.device_tag === tag.device_tag
        );

        let tagValue = mergedArray.length
          ? mergedArray.find(
              (f) =>
                f.device__uid == tag.device_uid &&
                f.device_tag == tag.device_tag
            )?.["tagValue"] || 0.0
          : 0.0;

        if (
          tag.is_soft_tag &&
          tag.soft_tag_id__formula &&
          mqttDataReduce[tag.device_uid]
        ) {
          const formulaResult = SoftTagFormula(
            tag.soft_tag_id__formula,
            mqttDataReduce[tag.device_uid]
          );

          tagValue = formulaResult.softTagNotGetTag
            ? formulaResult.value
            : tagValue;
        }
        const tagValue1 = tagValue;
        const tagName = tag?.tag_unit;
        if (tagName) {
          acc[tagName] = (acc[tagName] || 0) + parseFloat(tagValue1); // Accumulate tag values
        }
        return acc;
      }, {});
      return {
        plant_name: plant.plant_name,
        plant_id: plant.plant_id,
        ...matchingData,
      };
    });
    setUpdatedValues(updatedValues);

    // Summation value of selected plants
    const summation = updatedValues
      .filter((plant) => checkBoxPlantId.includes(plant.plant_id)) // Only include selected plants
      .reduce((acc, plant) => {
        Object.keys(plant).forEach((key) => {
          if (key !== "name" && key !== "plant_id" && key !== "plant_name") {
            acc[key] = (acc[key] || 0) + plant[key];
          }
        });
        return acc;
      }, {});

    setSummationValue(summation);

    // Average value for "PR%" and "CUF%" for selected plants
    const numSelectedPlants = checkBoxPlantId.length;
    const selectedPlants = updatedValues.filter((plant) =>
      checkBoxPlantId.includes(plant.plant_id)
    );

    const averageValues = {
      "PR%":
        numSelectedPlants > 0
          ? selectedPlants.reduce(
              (acc, plant) => acc + (plant["PR%"] || 0),
              0
            ) / numSelectedPlants
          : 0,
      "CUF%":
        numSelectedPlants > 0
          ? selectedPlants.reduce(
              (acc, plant) => acc + (plant["CUF%"] || 0),
              0
            ) / numSelectedPlants
          : 0,
    };

    setAverageValue(averageValues);
  }, [realTimePlantDta, mqttTagData, checkBoxPlantId]);

  const getBorderColor = (displayValue) => {
    if (displayValue > 80) {
      return "#68F195"; // Green
    } else if (displayValue >= 50 && displayValue <= 80) {
      return "#FE884B"; // Orange
    } else {
      return "#F55A48"; // Red
    }
  };

  const filteredPlants = plantData.map((e) => {
    // Find matching plant data
    const plantData12 = realTimePlantDta.find(
      (plantData1) => plantData1.plant_id === e.id
    );

    // Handle cases where plantData12 is not found
    if (!plantData12 || !plantData12.tags) {
      return {
        ...e,
        borderColor: "#F55A48", // Default color if no data is found
      };
    }

    // Flatten mqttTagData into an array
    const mergedArray = mqttTagData
      ? [].concat(...Object.values(mqttTagData))
      : [];

    // Get PR% tags
    const prTags = plantData12.tags.filter((tag) => tag.tag_unit === "PR%");

    // Extract the first valid tagValue
    const prTagValues = prTags.map((tag) => {
      const matchedItem = mergedArray.find(
        (item) =>
          item.device__uid === tag.device_uid &&
          item.device_tag === tag.device_tag
      );
      return matchedItem ? parseFloat(matchedItem.tagValue) : null;
    });

    // Calculate display value (default to 0.0 if no valid tagValue found)
    const displayValue =
      prTagValues.length > 0 && prTagValues[0] !== null ? prTagValues[0] : 0.0;

    // Determine border color based on display value
    const borderColor = getBorderColor(displayValue);

    // Return updated plant data with borderColor
    return {
      ...e,
      borderColor,
    };
  });

  const handleGenerationValue = async () => {
    const allowedIds = plant_access.map(p => p.id);
    const params = {
      plant_ids: plantData
      .map(e => e.id)
      .filter(id => allowedIds.includes(id)),
      generation_tag_unit: "MWh",
      start_date: `${startDate} 00:00:00`,
      end_date: `${endDate} 23:59:59`,
    };
    try {
      const resp = await getHikemmREPlantDashboardGenerationCount(params);
      if (resp.status === 200) {
        setTotalGeneration(resp.data.total_generation_value);
        setGenerationData(resp.data.data);
      }
    } catch (error) {
      console.log(
        "Error from getHikemmREPlantDashboardGenerationCount...",
        error
      );
    }
  };
  const handleTotalCapacityValue = async () => {
    const params = {
      plant_ids: allowedPlantIds,
    };
    try {
      const resp = await getHikemmREPlantCapacity(params);
      if (resp.status === 200) {
        setTotalCapacity(resp.data.total_plant_capacity);
        setTotalCapacityChartData(resp.data.data);
      }
    } catch (error) {
      console.log(
        "Error from getHikemmREPlantDashboardGenerationCount...",
        error
      );
    }
  };

  const handleC02EmissionValue = async () => {
    const params = {
      plant_ids: allowedPlantIds,
      co2_e_tag_unit: "kt",
    };
    if (startDate && endDate) {
      params.start_date = `${startDate} 00:00:00`;
      params.end_date = `${endDate} 23:59:59`;
    }
    try {
      const resp = await getHikemmREPlantDashboardCO2e(params);
      if (resp.status === 200) {
        setCo2Emission(resp.data.total_co2_e_value);
        setCo2BoxData(resp.data.data);
      }
    } catch (error) {
      console.log(
        "Error from getHikemmREPlantDashboardGenerationCount...",
        error
      );
    }
  };

  const handleCostSaving = async () => {
    const params = {
      plant_ids: allowedPlantIds,
      cost_saving_tag_unit: "Lac",
    };
    if (startDate && endDate) {
      params.start_date = `${startDate} 00:00:00`;
      params.end_date = `${endDate} 23:59:59`;
    }
    try {
      const resp = await getHikemmREPlantDashboardCostSaving(params);
      if (resp.status === 200) {
        setCostSaving(resp.data.total_cost_saving_value);
        setCostUnit(resp.data.tag_unit);
        setCostBoxData(resp.data.data);
      }
    } catch (error) {
      console.log("Error from getHikemmREPlantDashboardCostSaving...", error);
    }
  };

  const handleCo2Count = async () => {
    const allowedIds = plant_access.map(p => p.id);
    const params = {
      plant_ids: plantData
      .map(e => e.id)
      .filter(id => allowedIds.includes(id)),
      co2_green_tag_unit: "PR%",
      start_date: `${startDate} 00:00:00`,
      end_date: `${endDate} 23:59:59`,
    };
    try {
      const resp = await getHikemmREPlantDashboardCo2Count(params);
      if (resp.data.success == true) {
        setCo2CountData(resp.data.data);
        setCo2Percentage(resp.data.total_co2_green_value);
      }
    } catch (error) {
      console.log("Error from getHikemmREPlantDashboardCo2Count...", error);
    }
  };
  const handleUtilityCount = async () => {
    const allowedIds = plant_access.map(p => p.id);
    const params = {
      plant_ids: plantData
      .map(e => e.id)
      .filter(id => allowedIds.includes(id)),
      utilization_tag_unit: "CUF%",
      start_date: `${startDate} 00:00:00`,
      end_date: `${endDate} 23:59:59`,
    };
    try {
      const resp = await getHikemmREPlantDashboardUtilizationCount(params);
      if (resp.data.success == true) {
        setUtilityCountData(resp.data.data);
        setUtilityPercentage(resp.data.total_utilization_value);
      }
    } catch (error) {
      console.log("Error from getHikemmREPlantDashboardCo2Count...", error);
    }
  };
  const fetchedDailyGenerationOnMount = useRef(false);

  useEffect(() => {
    if (
      plantData.length > 0 &&
      checkBoxPlantId.length > 0 &&
      dailyGenStartDate &&
      dailyGenEndDate
    ) {
      // if (!fetchedDailyGenerationOnMount.current) {
      //   // Prevent the first duplicate API call on mount
      //   fetchedDailyGenerationOnMount.current = true;
      //   return;
      // }
      handleDailyGeneration(); // API call only when checkBoxPlantId changes
    }
  }, [checkBoxPlantId, dailyGenStartDate, dailyGenEndDate]);

  const handleDailyGeneration = async () => {
    if (plantData) {
      const params = {
        plant_ids: allowedPlantIds,
        tag_unit: "MWh",
        start_date: `${dailyGenStartDate} 00:00:00`,
        end_date: `${dailyGenEndDate} 23:59:59`,
      };
      try {
        const resp = await getHikemmREDashboardDailyGeneration(params);
        if (resp.data.success == true) {
          if (resp.data.success == true) {
            setDailyGenerationData(resp.data.payload);
          }
        }
      } catch (error) {
        setDailyGenerationData([]);
        console.log("Error from getHikemmREDashboardDailyGeneration...", error);
      }
    }
  };
  useEffect(() => {
    handleC02EmissionValue();
    handleCostSaving();
  }, [checkBoxPlantId, startDate, endDate]);

  useEffect(() => {
    if (!startDate || !endDate) {
      return; // Exit early if dates are invalid
    }

    if (plantData.length > 0) {
      handleGenerationValue();

      handleCo2Count();
      handleUtilityCount();
    }
  }, [startDate, endDate, plantData]);

  const fetchedTotalCapacityValueOnMount = useRef(false);

  useEffect(() => {
    if (plantData.length > 0 && checkBoxPlantId.length > 0) {
      if (!fetchedTotalCapacityValueOnMount.current) {
        // Prevent the first duplicate API call on mount
        fetchedTotalCapacityValueOnMount.current = true;
        return;
      }
      handleTotalCapacityValue(); // API call only when checkBoxPlantId changes
    }
  }, [checkBoxPlantId]);

  const colorCode = useMemo(
    () => ({
      56: "#FDBE4A",
      58: "#42899B",
      59: "#CE6A6C",
      57: "#E85AA0",
    }),
    []
  );
  const [mwValues, setMwValues] = useState([]);

  useEffect(() => {
    if (selectedPlantId.length === 1) {
      // Create a copy of the existing mwValues filtered for the selected plant_id
      let updatedMwValues = mwValues.filter(
        (item) => item.plant_id === selectedPlantId[0]
      );

      // Iterate through updatedValues
      updatedValues.forEach((newItem) => {
        // Check if the plant matches the selected plant_id
        if (newItem.plant_id === selectedPlantId[0]) {
          const existingIndex = updatedMwValues.findIndex(
            (item) => item.plant_id === newItem.plant_id
          );

          if (existingIndex !== -1) {
            // If it exists, ensure data array exists and add only if MW is not already in the array
            if (!updatedMwValues[existingIndex].data) {
              updatedMwValues[existingIndex].data = []; // Initialize data array if undefined
            }
            if (
              !updatedMwValues[existingIndex].data.some(
                (dataItem) => dataItem.MW === newItem.MW
              )
            ) {
              updatedMwValues[existingIndex].data.push({
                MW: newItem.MW,
                timestamp: new Date().toISOString(), // Add timestamp
              });
            }
          } else {
            // If it doesn't exist, add a new object with a data array
            updatedMwValues.push({
              plant_name: newItem.plant_name,
              plant_id: newItem.plant_id,
              data: [
                {
                  MW: newItem.MW,
                  timestamp: new Date().toISOString(), // Add timestamp
                },
              ], // Initialize data with the current MW and timestamp
            });
          }
        }
      });

      // Update the state
      setMwValues(updatedMwValues);
    }
  }, [updatedValues, selectedPlantId]);

  const handleCapacityGenerationTrend = async () => {
    if (!startDate || !endDate) return;
    const params = {
      plant_ids: allowedPlantIds,
      tag_unit: "MWh",
      start_date: `${startDate} 00:00:00`,
      end_date: `${endDate} 23:59:59`,
    };
    try {
      const resp = await getCapacityGenerationTrend(params);
      if (resp.status === 200) {
        setCapacityGenerationTrendData(resp.data.payload);
      }
    } catch (error) {
      console.log("Error from getCapacityGenerationTrend...", error);
    }
  };
  const fetchedCapacityGenerationTrendOnMount = useRef(false);

  useEffect(() => {
    if (
      plantData.length > 0 &&
      checkBoxPlantId.length > 0 &&
      startDate &&
      endDate
    ) {
      if (!fetchedCapacityGenerationTrendOnMount.current) {
        // Prevent the first duplicate API call on mount
        fetchedCapacityGenerationTrendOnMount.current = true;
        return;
      }
      handleCapacityGenerationTrend(); // API call only when checkBoxPlantId changes
    }
  }, [checkBoxPlantId, startDate, endDate]);

  const handleReDatails = async () => {
    const resp = await getHikEMMREPlantDetails();
    if (resp.status === 200 || resp.status == 201) {
      setHikemmRePlantDetails(resp.data.payload);
      setCapacity(resp.data);
    }
  };
  const handleToggleAutoChange = () => {
    setAutoChange(!autoChange);
  };

  const handleCheckboxChange = async (event) => {
    const isChecked = event.target.checked;
    setIsOthersChecked(isChecked);

    // Uncheck "All Plants" when "Others" is checked
    if (isChecked) {
      setIsAllSelected(false);

      // Clear selected plant IDs when "Others" is checked
      setSelectedPlantId([]);

      // Call the details function when "Others" is checked
      handleReDatails();

      // Fetch and process real-time data
      // await fetchRealTimeData();
      // await handleTotalCapacityValue1();
    } else {
      // Restore selected plant IDs or manage state as needed
      // Optionally keep the selected plant IDs or clear other details
      setHikemmRePlantDetails([]); // Clear details when "Others" is unchecked
      setIsAllSelected(true); // Restore "All Plants" when "Others" is unchecked
    }
  };

  const handleTotalCapacityValue1 = async () => {
    const params = {
      plant_ids: [],
    };
    try {
      const resp = await getHikemmREPlantCapacity(params);
      if (resp.status === 200) {
        setTotalCapacity(resp.data.total_plant_capacity);
        setTotalCapacityChartData(resp.data.data);
      }
    } catch (error) {
      console.log(
        "Error from getHikemmREPlantDashboardGenerationCount...",
        error
      );
    }
  };

  // Separate function for fetching real-time data
  const fetchRealTimeData = async () => {
    const params = {
      plant_ids: [],
      generation_tag_unit: "MW",
      co2_e_tag_unit: "kt",
      cost_saving_tag_unit: "Lac",
      performance_tag_unit: "PR%",
      utilization_tag_unit: "CUF%",
    };

    try {
      const resp = await getHikemmREDashboardTagsData(params);
      if (resp.status === 200 || resp.status === 201) {
        const tagsData = resp.data.payload;
        setRealTimePlantData(tagsData);

        const tagDataList = tagsData.flatMap((plant) =>
          plant.tags.map((tag) => ({
            dvName: tag.device_tag || "-",
            tagName: tag.tag_name,
            machineUID: tag.device_uid,
            is_soft_tag: tag.is_soft_tag || false,
            soft_tag_id__formula: tag.soft_tag_id__formula || null,
          }))
        );

        // Combine default and calculated tags if needed
        setTagListDataGroupAndList(tagDataList);

        // Evaluate formula if it's a soft tag
        const evaluateSoftTagValue = (formula, tags) => {
          try {
            const tagPattern = /[A-Za-z0-9_]+/g;
            const tagMatches = formula.match(tagPattern) || [];
            let evaluatedFormula = formula;

            // Replace tags in formula with current values from tags list
            tagMatches.forEach((tag) => {
              const foundTag = tags.find((t) => t.dvName === tag);
              const tagValue = foundTag ? parseFloat(foundTag.curValue) : 0;
              evaluatedFormula = evaluatedFormula.replace(tag, tagValue);
            });

            return eval(evaluatedFormula);
          } catch {
            return 0; // Default to 0 on error
          }
        };

        const tagObj = tagsData.flatMap((plant) =>
          plant.tags.map((tag) => {
            let curValue = 0;
            let prevValue = 0;

            if (tag.is_soft_tag && tag.soft_tag_id__formula) {
              // Evaluate the formula for the soft tag using the provided method
              curValue = evaluateSoftTagValue(
                tag.soft_tag_id__formula,
                mqttTagPreviousvalue
              );
              prevValue = curValue; // Assuming prevValue is the same as curValue initially
            }

            return {
              is_soft_tag: tag.is_soft_tag,
              dvName: tag.device_tag || "-",
              prevValue,
              curValue,
              dateAndTime: getTagDateAndTime(),
              soft_tag_id__formula: tag.soft_tag_id__formula,
            };
          })
        );

        setMqttTagPreviousvalue(tagObj);
      }
    } catch (error) {
      console.log("Error fetching data", error);
    }
  };

  return (
    <>
      <ToastContainer />
      <div className="Bpcl-page-wrapper">
        {realTimeData.length ? (
          <OverViewMachineMqttData
            topics={topics}
            tagListDataGroupAndList={tagListDataGroupAndList}
            setMqttTagPreviousvalue={setMqttTagPreviousvalue}
            mqttTagPreviousvalue={mqttTagPreviousvalue}
            setSliderRealTimeTagData={setSliderRealTimeTagData}
            mqttTagData={mqttTagData}
            setMqttTagData={setMqttTagData}
          />
        ) : null}

        <>
          <Grid container spacing={1}>
            <Grid item xs={12} md={3}>
              <div style={{ backgroundColor: "white", borderRadius: "8px" }}>
                <Box className="plant-list">
                  <Grid container spacing={1}>
                    <Grid item xs={12} md={6}>
                      {/* Total Capacity */}
                      <Box className="plant-item total-capacity">
                        <div>
                          <img src={images.suryaTotalCapacity} />
                        </div>
                        <div style={{ textAlign: "left" }}>
                          <div className="title">Total Capacity (DC)</div>
                          <div className="value">
                            {parseFloat(totalCapacity).toFixed(2)}{" "}
                            <span
                              style={{
                                color: "#000",
                                fontSize: "12px",
                                fontWeight: "300",
                              }}
                            >
                              MWp{" "}
                            </span>{" "}
                          </div>
                        </div>
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      {/* Generation */}
                      <Box className="plant-item generation">
                        <div>
                          <img src={images.suryaTotalCapacity} />
                        </div>
                        <div style={{ textAlign: "left" }}>
                          {" "}
                          <div className="title">Generation (DC)</div>
                          <div className="value">
                            {startDate && endDate
                              ? (() => {
                                  const selectedPlant = generationData.find(
                                    (plant) => plant.plant_id == checkBoxPlantId
                                  );

                                  return selectedPlant
                                    ? Number(
                                        selectedPlant.generation_value
                                      ).toFixed(2)
                                    : totalGeneration;
                                })()
                              : has58 || has59
                              ? isNaN(DCvalue)
                                ? "0.00"
                                : Number(DCvalue).toFixed(2)
                              : isNaN(parseFloat(summationValue.MW))
                              ? 0
                              : has58 || has59
                              ? isNaN(DCvalue)
                                ? "0.00"
                                : Number(DCvalue).toFixed(2)
                              : parseFloat(summationValue.MW).toFixed(2)}

                            <span
                              style={{
                                color: "#000",
                                fontSize: "12px",
                                fontWeight: "300",
                              }}
                            >
                              {" "}
                              {startDate && endDate ? "MWh" : "MW"}{" "}
                            </span>
                          </div>
                        </div>
                      </Box>
                    </Grid>
                  </Grid>
                  <Grid container spacing={1} style={{ marginTop: "10px" }}>
                    <Grid item xs={12} md={6}>
                      {/* CO2 Emission */}
                      <Box className="plant-item co2-emission">
                        <div>
                          <img src={images.suryaCo2Emission} />
                        </div>
                        <div style={{ textAlign: "left" }}>
                          <div className="title">
                            CO<sub>2</sub>e
                          </div>
                          <div className="value ">
                            {co2Emission}

                            <span
                              style={{
                                color: "#000",
                                fontSize: "12px",
                                fontWeight: "300",
                              }}
                            >
                              {" "}
                              kt{" "}
                            </span>
                          </div>
                        </div>
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      {/* Cost Savings */}
                      <Box className="plant-item cost-savings">
                        <div>
                          <img src={images.suryaTotalSavingIcon} />
                        </div>
                        <div style={{ textAlign: "left" }}>
                          <div className="title">Cost Savings (INR)</div>
                          <div className="value">
                            {/* {startDate && endDate
                              ? (() => {
                                  const selectedPlant = costBoxData.find(
                                    (plant) => plant.plant_id == checkBoxPlantId
                                  );

                                  return selectedPlant
                                    ? Number(
                                        selectedPlant.cost_saving_value
                                      ).toFixed(2)
                                    : costSaving;
                                })()
                              : isNaN(parseFloat(summationValue.Lac))
                              ? "0.00"
                              : parseFloat(summationValue.Lac).toFixed(2)} */}
                            {costSaving}

                            <span
                              style={{
                                color: "#000",
                                fontSize: "12px",
                                fontWeight: "300",
                              }}
                            >
                              {" "}
                              {costUnit}{" "}
                            </span>
                          </div>
                        </div>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
                <Box className="generate-report" style={{ marginTop: "5px" }}>
                  <div className="report-title">
                    Generation
                    <span
                      className="report-title-span"
                      onMouseEnter={() => setShowInfo(true)} // Show on hover
                      onMouseLeave={() => setShowInfo(false)} // Hide when hover ends
                    >
                      <img
                        src={images.infoIconBlack}
                        style={{ width: "20px" }}
                      />
                    </span>
                  </div>
                  {showInfo && (
                    <div className="toggle-info">
                      This pie chart illustrates the total power generation
                      along with the contributions from each plants.
                    </div>
                  )}

                  <div className="report-text">
                    <p className="mb-0">
                      Total Generations (DC)
                      <br />
                      <b>
                        {startDate && endDate
                          ? totalGeneration
                          : parseFloat(summationValue.MW).toFixed(2)}{" "}
                        {startDate && endDate ? " MWh" : " MW"}
                      </b>
                    </p>
                  </div>
                  <PieChart
                    generationData={
                      startDate && endDate
                        ? generationData // When startDate and endDate are defined
                        : updatedValues.map(({ plant_name, plant_id, MW }) => ({
                            plant_name,
                            plant_id,
                            MW,
                          })) // Only send plant_name, plant_id, and MW
                    }
                    colorCode={colorCode}
                    selectedPlantId={selectedPlantId}
                    startDate={startDate}
                    endDate={endDate}
                  />
                </Box>
                <Box
                  className="capacity-generation-report"
                  style={{ marginTop: "5px" }}
                >
                  <div className="report-title">
                    Capacity Generation Trend
                    <span
                      className="report-title-span"
                      onMouseEnter={() => setShowInfo1(true)} // Show on hover
                      onMouseLeave={() => setShowInfo1(false)} // Hide when hover ends
                    >
                      <img
                        src={images.infoIconBlack}
                        style={{ width: "20px" }}
                      />
                    </span>
                  </div>
                  {showInfo1 && (
                    <div className="toggle-info">
                      This trend illustrates the individual capacity of all the
                      plants along with the generation in line graph.
                    </div>
                  )}
                  <div>
                    {/* Check if single plant is selected */}
                    {selectedPlantId.length === 1 ? (
                      // Check if date range is selected
                      startDate && endDate ? (
                        // Show capacity generation trend for single plant with date range
                        <SinglePlantCombineChart
                          // Map capacity data for bar chart
                          barChartData={capacityGenerationTrendData.map(
                            (item, index) => ({
                              plant_id: item.plant_id,
                              plant_name: item.plant_name,
                              capacity_data: item.capacity_data,
                            })
                          )}
                          // Map generation data for line chart
                          lineChartData={capacityGenerationTrendData.map(
                            (item) => ({
                              plant_id: item.plant_id,
                              plant_name: item.plant_name,
                              generation_value: item.generation_data,
                            })
                          )}
                          colorCode={colorCode}
                          selectedPlantId={selectedPlantId}
                          unit="MWh"
                        />
                      ) : (
                        // Show live plant data for single plant without date range
                        <LivePlantCombineChart
                          // Filter capacity data for selected plant
                          barChartData={totalCapacityChartData.filter((plant) =>
                            selectedPlantId.includes(plant.plant_id)
                          )}
                          lineChartData={mwValues}
                          colorCode={colorCode}
                          selectedPlantId={selectedPlantId}
                          unit="MW"
                        />
                      )
                    ) : startDate && endDate ? (
                      // Show combined chart for multiple plants with date range
                      <CombinedChart
                        barChartData={totalCapacityChartData}
                        lineChartData={generationData}
                        colorCode={colorCode}
                        unit="MWh"
                      />
                    ) : (
                      // Show combined chart for multiple plants without date range
                      <CombinedChart
                        barChartData={totalCapacityChartData}
                        // Map live MW values for line chart
                        lineChartData={updatedValues.map((item) => ({
                          plant_id: item.plant_id,
                          plant_name: item.plant_name,
                          generation_value: item.MW,
                        }))}
                        colorCode={colorCode}
                        unit="MW"
                      />
                    )}
                  </div>
                </Box>
              </div>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box
                className="map-box"
                style={{ position: "relative", height: "593px" }}
              >
                <Box
                  id="map-container"
                  className="map-div"
                  style={{ position: "relative" }}
                >
                  {isOthersChecked ? (
                    <>
                      <div
                        style={{
                          position: "absolute",
                          bottom: "80px",
                          left: "10px",
                          padding: "8px",
                          backgroundColor: "white",
                          color: "black",
                          borderRadius: "5px",
                          zIndex: 1,
                        }}
                      >
                        <b>Solar:</b> {capacity?.solar_capacity}{" "}
                      </div>

                      <div
                        style={{
                          position: "absolute",
                          bottom: "30px",
                          left: "10px",
                          padding: "8px",
                          backgroundColor: "white",
                          color: "black",
                          borderRadius: "5px",
                          zIndex: 1,
                        }}
                      >
                        <b>Wind:</b> {capacity?.wind_capacity}{" "}
                      </div>
                      <div
                        style={{
                          position: "absolute",
                          bottom: "-18px",
                          left: "10px",
                          padding: "8px",
                          backgroundColor: "white",
                          color: "black",
                          borderRadius: "5px",
                          zIndex: 1,
                        }}
                      >
                        <b>Total Capacity:</b> {capacity?.total_capacity}{" "}
                      </div>
                    </>
                  ) : (
                    ""
                  )}

                  <div
                    style={{
                      position: "absolute",
                      top: "5px",
                      left: "0px",
                      padding: "8px",
                      borderRadius: "5px",
                      zIndex: 1,
                    }}
                  >
                    <Box className="map-plant">
                      <div>
                        {/* Button to open the "Select Plants" menu */}
                        <Button
                          onClick={handleMenuClick}
                          variant="outlined"
                          className="select-plant-btn"
                        >
                          Select Plants
                        </Button>

                        {/* Menu displaying the list of plants with checkboxes */}
                        <Menu
                          anchorEl={anchorEl}
                          open={Boolean(anchorEl)}
                          onClose={handleMenuClose}
                        >
                          {/* "All Plants" checkbox */}
                          <MenuItem value="all">
                            <Checkbox
                              checked={isAllSelected}
                              onChange={() => handlePlantSelected(["all"])}
                            />
                            <ListItemText primary="All Plants" />
                          </MenuItem>

                          {/* Individual plants */}
                          {plantData.map((plant, index) => {
                            const hasAccess = plant_access.some(
                              (company) =>
                                company.plant_name === plant.plant_name
                            );
                            return (
                              <MenuItem key={index} value={plant.id}>
                                <Checkbox
                                  checked={
                                    hasAccess &&
                                    selectedPlantId.includes(plant.id)
                                  }
                                  onChange={() => {
                                    if (!hasAccess) {
                                      notifyError("You don't have access");
                                      return;
                                    }
                                    handlePlantSelected([plant.id]); // Only pass the plant's ID here
                                  }}
                                />
                                <ListItemText primary={plant.plant_name} />
                              </MenuItem>
                            );
                          })}

                          {/* "Others" checkbox */}
                          <MenuItem value="others">
                            <Checkbox
                              checked={isOthersChecked}
                              onChange={handleCheckboxChange} // Use the handler for toggling "Others"
                            />
                            <ListItemText primary="Others" />
                          </MenuItem>
                        </Menu>
                      </div>
                    </Box>
                  </div>
                  <div
                    style={{
                      position: "absolute",
                      top: "5px",
                      right: "-2px",
                      padding: "8px",
                      borderRadius: "5px",
                      zIndex: 1,
                    }}
                  >
                    <Datepicker3
                      startDate={startDate}
                      setStartDate={setStartDate}
                      endDate={endDate}
                      setEndDate={setEndDate}
                    />
                  </div>

                  {/* Add two button to select next plant */}

                  <Box
                    style={{
                      position: "absolute",
                      bottom: isFullscreen
                        ? "-29px"
                        : isSolarFullScreen
                        ? "11px"
                        : "-26px",
                      right: "90px",
                      zIndex: 1,
                      border: "none",
                      borderRadius: "5px",
                      cursor: "pointer",
                      display: "flex",
                    }}
                  >
                    <Box
                      sx={{
                        border: "1px solid #000",
                        backgroundColor: "#fff",
                        borderRadius: "5px",
                        margin: "5px",
                      }}
                    >
                      <IconButton
                        onClick={handleToggleAutoChange}
                        color="primary"
                      >
                        {autoChange ? <PauseIcon /> : <PlayArrowIcon />}
                      </IconButton>
                    </Box>

                    <button
                      onClick={selectPreviousPlant}
                      style={{
                        border: "none",
                        borderRight: "1px solid #000",
                        backgroundColor: "#fff",
                        width: "40px",
                        height: "40px",
                        borderRadius: "5px 0px 0px 5px",
                        marginLeft: "3px",
                        marginTop: "6px",
                      }}
                    >
                      <ArrowBackIosIcon style={{ width: "15px" }} />
                    </button>
                    <button
                      onClick={selectNextPlant}
                      style={{
                        border: "none",
                        backgroundColor: "#fff",
                        width: "40px",
                        height: "40px",
                        borderRadius: "0px 5px 5px 0px",
                        marginRight: "15px",
                        marginTop: "6px",
                      }}
                    >
                      <ArrowForwardIosIcon style={{ width: "15px" }} />
                    </button>
                  </Box>
                  {/*Add a button to toggle fullscreen */}
                  <button
                    onClick={toggleFullscreen}
                    style={{
                      position: "absolute",
                      bottom: isFullscreen
                        ? "-23px"
                        : isSolarFullScreen
                        ? "18px"
                        : "-19px",
                      right: "57px",
                      zIndex: 1,
                      backgroundColor: "#fff",
                      border: "none",
                      cursor: "pointer",
                      width: "40px",
                      height: "40px",
                      borderRadius: "5px",
                    }}
                  >
                    {isSolarFullScreen ? (
                      <CloseFullscreenIcon style={{ width: "15px" }} />
                    ) : (
                      <OpenInFullIcon style={{ width: "15px" }} />
                    )}
                  </button>
                  <MapComponent1
                    location={SelctedplantLocation}
                    plantName={selectedPlantName}
                    selectedImage={selectedPlantImage}
                    allPlant={allPlant}
                    plantId={selectedPlantId}
                    companyId={params.id}
                    plantData={filteredPlants}
                    plantAllData={plantData}
                    isSolarFullScreen={isSolarFullScreen}
                    setIsFullscreen={setIsFullscreen}
                    isFullscreen={isFullscreen}
                    hikemmRePlantDetails={hikemmRePlantDetails}
                    plant_access={plant_access}
                  />
                </Box>
              </Box>
              <Box className="daily-generation">
                <div className="daily-generation-title">
                  <b className="daily-title">DAILY GENERATION PATTERN</b>
                  <div className="d-flex gap-2">
                    <Select
                      value={selectTimeRange}
                      onChange={(event) => handleDropdown(event)}
                      className="inpute-week"
                      style={{ marginLeft: "107px" }}
                    >
                      <MenuItem value="1min">1 min</MenuItem>
                      <MenuItem value="5min">5 min</MenuItem>
                      <MenuItem value="15min">15 min</MenuItem>
                      <MenuItem value="Hour">Hour</MenuItem>
                    </Select>
                    <span>
                      <Datepicker3
                        startDate={dailyGenStartDate}
                        setStartDate={setDailyGenStartDate}
                        endDate={dailyGenEndDate}
                        setEndDate={setDailyGenEndDate}
                      />
                    </span>
                  </div>
                </div>
                <AreaChart
                  chartData={dailyGenerationData}
                  colorCode={colorCode}
                  timeRange={selectTimeRange}
                  startDate={dailyGenStartDate}
                  endDate={dailyGenEndDate}
                  cubeData={cubeData}
                  selectedPlantId={selectedPlantId}
                  checkBoxPlantId={checkBoxPlantId}
                  isOthersChecked={isOthersChecked}
                />
              </Box>
            </Grid>
            <Grid item xs={12} md={3}>
              <div
                style={{
                  backgroundColor: "white",
                  paddingTop: "10px",
                  borderRadius: "8px",
                }}
              >
                <Box className="insight-box">
                  <div className="report-title" style={{ display: "block" }}>
                    Insights (
                    <span style={{ textTransform: "lowercase" }}>
                      powered by
                    </span>{" "}
                    <span className="powered-by">AI</span>)
                  </div>

                  {/* Slider for insight text */}
                  <Slider
                    {...settings}
                    dots={true}
                    customPaging={(i) => <div className="custom-dot"></div>}
                    appendDots={(dots) => (
                      <ul className="slick-dots">{dots.slice(0, 4)}</ul>
                    )}
                  >
                    {insightAPIData.length > 0 ? (
                      insightAPIData.map((e) => {
                        return <div className="insight-text">{e}</div>;
                      })
                    ) : (
                      <div className="insight-text"></div>
                    )}
                  </Slider>
                </Box>

                {/* Add more Box components here for additional slides */}

                <Box
                  className="performance-ratio"
                  style={{ marginTop: "25px", paddingBottom: "15px" }}
                >
                  <div className="report-title">
                    Performance Ratio
                    <span
                      className="report-title-span"
                      onMouseEnter={() => setShowInfo2(true)} // Show on hover
                      onMouseLeave={() => setShowInfo2(false)} // Hide when hover ends
                    >
                      <img
                        src={images.infoIconBlack}
                        style={{ width: "20px" }}
                        alt=""
                      />
                    </span>
                  </div>
                  {showInfo2 && (
                    <div className="toggle-info-popup">
                      This pie chart illustrates the total PR along with the
                      contribution from each plants.
                    </div>
                  )}
                  <GuageChart
                    chartData={generationCurrentData}
                    colorCode={colorCode}
                    chart="performance"
                    selectedPlantId={selectedPlantId}
                  />
                  <div className="performance-plant-list">
                    <Marquee pauseOnHover={true}>
                      {/* Assuming you have a 'chartType' prop or state that indicates 'performance' or 'utilization' */}
                      {/* For example, let's assume `currentChartMetric` is a prop/state that holds 'pr' or 'cuf' */}
                      {generationCurrentData.map((item, index) => {
                        const isChecked = checkBoxPlantId.includes(
                          item.plant_id
                        );
                        console.log(
                          "isCheckedisCheckedisChecked",
                          checkBoxPlantId,
                          item.plant_id
                        );
                        const backgroundColor = isChecked
                          ? colorCode[item.plant_id]
                          : "#918c8c";

                        // Determine which value to display based on the selected chart metric
                        let displayValue = 0;
                        let displayUnit = "";

                        // You need a way to know if you're showing "PR" or "CUF"
                        // Let's assume you have a prop called `activeChartType` (e.g., "performance" or "utilization")
                        // or directly use a variable like `showPR` or `showCUF`
                        // For this example, let's assume `chart` prop from the GuageChart context is also available or derivable.
                        // If `chart` prop is "performance", show PR; if "utilization", show CUF.
                        const chartType = "performance"; // Replace with your actual chart type prop/state (e.g., props.chart)

                        if (chartType === "performance") {
                          displayValue = item.payload.pr.current_avg;
                          displayUnit = item.payload.pr.tag_unit; // "PR%"
                        }

                        return (
                          <div
                            key={index}
                            className="performance-plant-item"
                            style={{ backgroundColor }}
                          >
                            <div className="plant-name">
                              {/* If you have a plant_name associated with plant_id, use it. */}
                              {/* Otherwise, display plant_id or fetch plant names from a separate source. */}
                              {item.plant_name}
                            </div>
                            <div className="plant-value">
                              {Math.round(displayValue * 100) / 100}%{" "}
                              {/* Display value rounded to 2 decimal places with percentage sign */}
                            </div>
                          </div>
                        );
                      })}
                    </Marquee>
                  </div>
                </Box>
                <Box
                  className="capacity-utilization"
                  style={{ marginTop: "10px", paddingBottom: "20px" }}
                >
                  <div className="report-title">
                    Capacity Utilization Factor
                    <span
                      className="report-title-span"
                      onMouseEnter={() => setShowInfo3(true)} // Show on hover
                      onMouseLeave={() => setShowInfo3(false)} // Hide when hover ends
                    >
                      <img
                        src={images.infoIconBlack}
                        style={{ width: "20px" }}
                      />
                    </span>
                  </div>
                  {showInfo3 && (
                    <div className="toggle-info-popup">
                      This pie chart illustrates the total CUF along with the
                      contribution from each plants.
                    </div>
                  )}

                  <GuageChart
                    chartData={generationCurrentData}
                    colorCode={colorCode}
                    chart="utilization"
                    selectedPlantId={selectedPlantId}
                  />
                  {/*flex div with scrolling and the  div take the background color of the data*/}
                  <div className="performance-plant-list">
                    <Marquee pauseOnHover={true}>
                      {/* Assuming you have a 'chartType' prop or state that indicates 'performance' or 'utilization' */}
                      {/* For example, let's assume `currentChartMetric` is a prop/state that holds 'pr' or 'cuf' */}
                      {generationCurrentData.map((item, index) => {
                        const isChecked = checkBoxPlantId.includes(
                          item.plant_id
                        );
                        const backgroundColor = isChecked
                          ? colorCode[item.plant_id]
                          : "#918c8c";

                        // Determine which value to display based on the selected chart metric
                        let displayValue = 0;
                        let displayUnit = "";

                        // You need a way to know if you're showing "PR" or "CUF"
                        // Let's assume you have a prop called `activeChartType` (e.g., "performance" or "utilization")
                        // or directly use a variable like `showPR` or `showCUF`
                        // For this example, let's assume `chart` prop from the GuageChart context is also available or derivable.
                        // If `chart` prop is "performance", show PR; if "utilization", show CUF.
                        const chartType = "utilization"; // Replace with your actual chart type prop/state (e.g., props.chart)

                        if (
                          chartType === "performance" &&
                          item.payload?.pr?.current_avg !== undefined
                        ) {
                          displayValue = item.payload.pr.current_avg;
                          displayUnit = item.payload.pr.tag_unit; // "PR%"
                        } else if (
                          chartType === "utilization" &&
                          item.payload?.cuf?.current_avg !== undefined
                        ) {
                          displayValue = item.payload.cuf.current_avg;
                          displayUnit = item.payload.cuf.tag_unit; // "CUF%"
                        }

                        return (
                          <div
                            key={index}
                            className="performance-plant-item"
                            style={{ backgroundColor }}
                          >
                            <div className="plant-name">
                              {/* If you have a plant_name associated with plant_id, use it. */}
                              {/* Otherwise, display plant_id or fetch plant names from a separate source. */}
                              {item.plant_name}
                            </div>
                            <div className="plant-value">
                              {Math.round(displayValue * 100) / 100}%{" "}
                              {/* Display value rounded to 2 decimal places with percentage sign */}
                            </div>
                          </div>
                        );
                      })}
                    </Marquee>
                  </div>
                </Box>
              </div>
            </Grid>
          </Grid>
        </>
      </div>
    </>
  );
};

export default SolarBPCLPlantDashboard;
